<template>
    <div>

        <div v-if="contentLoaing && isBlocked" class="p-4 bg-red-50 border border-red-200 rounded-lg">
            <p class="font-semibold text-red-700">Доступ к тесту заблокирован.</p>
            <p class="text-sm text-red-600 mt-1">Обратитесь к модератору для сброса попыток и уточнения условий повторного прохождения.</p>
        </div>
        <div v-else-if="contentLoaing && noActiveApplication" class="p-4 bg-red-50 border border-red-200 rounded-lg">
            <p class="font-semibold text-red-700">Доступ к тесту закрыт.</p>
            <p class="text-sm text-red-600 mt-1">Нет активной одобренной заявки на курс. Подайте заявку повторно.</p>
        </div>
        <h1
            v-else-if="contentLoaing && !canTesting"
            class="font-semibold">Тест был пройден, ваш бал - <b>{{ testResult }}</b></h1>

        <button
            v-if="contentLoaing && canTesting && !testing"
            @click="() => {this.testing = true;}"
            class="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
            type="button"
            style="width: 100%"
        >
            <span>Пройти тест</span>
        </button>

        <div
            v-if="contentLoaing && canTesting && testing && questionsData.length > 0" >
            <ul 
                style="width: 100%;"
                class="ml-2 max-w-md space-y-1 text-gray-500 list-inside dark:text-gray-400 text-left mb-5"
            >
                <li v-for="(el, ind) in questionsData"
                style="width: 100%;"
                :key="ind"
                >
                    <div 
                        style="font-size: 18px"
                        class="font-semibold inl-100 mb-3"> {{ ind+1}}. {{ el.question }}</div>

                    <div
                        v-for="(answer, answerInd) in el.question_answers"
                        :key="answerInd">
                        <span>
                            <input
                                type="checkbox"
                                :value="answer.id"
                                :checked="answers[el.id].includes(answer.id)"
                                @change="toggleAnswer(el.id, answer.id)"
                                >
                        </span>
                        <span class="pl-3">{{ answer.answer }}</span>
                    </div>
                </li>
            </ul>

            <button
                @click="saveData"
                :disabled="isSubmitting"
                class="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-500"
                type="button"
                style="width: 100%"
            >
                <span v-if="!isSubmitting">Закончить тест</span>
                <span v-else class="inline-flex items-center gap-2">
                    <svg class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Обработка...
                </span>
            </button>

        </div>


    </div>
</template>

<script>
import { API_CLIENT, HEADERS_TOKEN_JSON } from '@/const/uri';
import axios from 'axios';
import { mapActions } from 'vuex';

export default {
    emits: ['active'],
    data() {
        return {
            contentLoaing: false,
            canTesting: false,
            isBlocked: false,
            noActiveApplication: false,
            testing: false,
            questionsData: [],
            answers: {},
            testResult: false,
            isSubmitting: false,
        }
    },
    mounted() {
        this.loadData();
    },
    beforeUnmount() {
        window.removeEventListener('beforeunload', this.onBeforeUnload);
    },
    beforeRouteUpdate(to, from, next) {
        this.loadData();
        next();
    },
    watch: {
        testing(val) {
            this.setBeforeUnload(val);
            this.$emit('active', val);
        },
    },
    methods: {
        ...mapActions(['toggleAlert']),
        onBeforeUnload(e) {
            e.preventDefault();
            e.returnValue = '';
        },
        setBeforeUnload(active) {
            if (active) {
                window.addEventListener('beforeunload', this.onBeforeUnload);
            } else {
                window.removeEventListener('beforeunload', this.onBeforeUnload);
            }
        },
        toggleAnswer(questionId, answerId) {
            // Добавляем или удаляем ответ из массива выбранных ответов
            const answers = this.answers[questionId];
            const index = answers.indexOf(answerId);
            if (index > -1) {
                answers.splice(index, 1);
            } else {
                answers.push(answerId);
            }
        },
        shuffle(array) {
            let currentIndex = array.length,  randomIndex;
            while (currentIndex > 0) {
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex--;
                [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]];
            }
            return array;
        }, 
       createAnswers(data) {
            const obj = {};
            data.forEach(el => {
                // Теперь поддерживаем множественные ответы - используем массив
                obj[el.id] = [];
            });
            this.answers = obj;
       },
       async loadData() {
            await axios({
                method: "GET",
                url: API_CLIENT.questions +  this.$route.params.themeUUID + '/',
                headers: HEADERS_TOKEN_JSON(),
                data: {

                },
            })
            .then((e) => {
                this.questionsData = e.data.data.questions;
                this.createAnswers(this.questionsData);
                this.contentLoaing = true;
                this.canTesting = e.data.data.can_testing;
                this.isBlocked = e.data.data.is_blocked || false;
                this.noActiveApplication = e.data.data.no_active_application || false;
                this.testResult = e.data.data.result;
            })
            .catch(function (e) {
                console.log(e);
            });
       },
       async saveData() {
            if (this.isSubmitting) return; // Защита от двойного клика
            this.isSubmitting = true;
            try {
                await axios({
                    method: "POST",
                    url: API_CLIENT.questions +  this.$route.params.themeUUID + '/answers/',
                    headers: HEADERS_TOKEN_JSON(),
                    data: {
                        answers: this.answers,
                    },
                })
                .then((e) => {
                    this.testing = false;
                    this.canTesting = false;
                    this.testResult = e.data.data.result.value;
                    const isBlock = e.data.data.result.is_block;
                    if(!isBlock) {
                        setTimeout(() => {
                            location.reload();
                        }, 750);
                    } else {
                        const result = e.data.data.result;
                        const attemptsLeft = (result.max_attempts || 4) - (result.attempts_used || 0);
                        let message = 'Доступ к курсу заблокирован. Оставьте повторную заявку.';
                        if (attemptsLeft > 0) {
                            message += ` У вас осталось ${attemptsLeft} попыток для повторного прохождения курса.`;
                        } else {
                            message += ' Попытки исчерпаны.';
                        }
                        message += ' Возможно потребуется повторная оплата курса - обратитесь к модератору за уточнением деталей.';
                        this.toggleAlert({
                            message: message,
                            isError: true,
                        });
                    }
                })
                .catch(function (e) {
                    console.log(e);
                });
            } finally {
                this.isSubmitting = false;
            }
       }  
    }, 
    props: {
        questionUUID: {}
    }
}
</script>